import { render, staticRenderFns } from "./NumberNavigation.vue?vue&type=template&id=71823b9b&scoped=true&"
import script from "./NumberNavigation.vue?vue&type=script&lang=js&"
export * from "./NumberNavigation.vue?vue&type=script&lang=js&"
import style0 from "./NumberNavigation.vue?vue&type=style&index=0&id=71823b9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71823b9b",
  null
  
)

export default component.exports